import { Button } from '@accure/ui';
import { ChevronRight } from 'lucide-react';

import { Card } from '@/components/ui/card';
import type { Alert } from '@/entities/alert';
import { ConditionViolationsChart } from '@/warranty-v3/pages/warranty/components/data/condition-violations/condition-violations-chart';
import { GetDataQuery } from '@/warranty-v3/queries/get-data';

import { lookerStyle } from '../warranty-preview-shared/looker-style';
import { PreviewLayout } from '../warranty-preview-shared/preview-layout';
import { TableSuggestedActions } from '../warranty-preview-shared/table-suggested-actions';
import { WarrantyDetailsLink } from '../warranty-preview-shared/warranty-details-link';

export type WarrantyConditionPreviewProps = {
  alert: Alert;
};

export function WarrantyConditionPreview({
  alert,
}: WarrantyConditionPreviewProps) {
  const style = lookerStyle();

  const data = GetDataQuery.useQuery({
    systemId: alert.id,
    selectedFilters: {},
  });

  if (data.isLoading) {
    return null;
  }

  if (data.isError || !data.data) {
    throw data.error;
  }

  return (
    <PreviewLayout
      chart={
        <Card className="flex h-full flex-col items-center rounded-lg border border-gray-200 bg-white px-2 py-3 shadow-lg">
          <ConditionViolationsChart
            conditionViolations={data.data.conditionViolations}
          />
        </Card>
      }
      table={
        <Card className="flex h-full flex-col items-center rounded-lg border border-gray-200 bg-white px-2 py-3 shadow-lg">
          <h2 className={style.headline()}>Suggested Actions</h2>
          <TableSuggestedActions alert={alert} />
        </Card>
      }
      link={
        <WarrantyDetailsLink alert={alert}>
          <Button size="lg" data-testid="alert-get-more-details-button">
            Get more details
            <ChevronRight />
          </Button>
        </WarrantyDetailsLink>
      }
    />
  );
}
